<script setup>
import App from "components/App";

const props = defineProps(["target"]);

function login() {
	try {
		const target = new URL(location.origin + props.target);

		if (target.origin === location.origin)
			location.assign(target.href);
		else
			location.assign("/");
	}
	catch (e) {
		location.assign("/");
	}
}
</script>

<template>
	<App @login="login()"/>
</template>
